import { render, staticRenderFns } from "./BlockSelect.vue?vue&type=template&id=463be73a&scoped=true&"
import script from "./BlockSelect.vue?vue&type=script&lang=js&"
export * from "./BlockSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463be73a",
  null
  
)

export default component.exports